export default __webpack_public_path__ + "static/media/img2.6fab7c82.png";